/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Directive, OnInit, OnDestroy, NgModuleRef, ViewContainerRef, Input } from '@angular/core';

import { ELazyModules } from '../core/models';
import { LazyLoaderService } from './lazy-loader.service';

@Directive({
  selector: '[fmLoadModule]'
})
export class LoadModuleDirective implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('fmLoadModule') moduleName: ELazyModules;
  @Input('fmLoadModuleDestroyModuleWithComponent') destroyModuleWithComponent = true;

  private _moduleRef: NgModuleRef<any>;

  constructor(private readonly _vcr: ViewContainerRef, private readonly _loaderService: LazyLoaderService) {}

  ngOnInit(): void {
    this._loaderService.load(this.moduleName, this._vcr).then(moduleRef => (this._moduleRef = moduleRef));
  }
  ngOnDestroy(): void {
    if (this._moduleRef && this.destroyModuleWithComponent) {
      this._moduleRef.destroy();
    }
  }
}
